import SvgIcon from '@/pages/home/components/SvgIcon';
import BubbleCommon, {
  TipsMapType,
} from '@/pages/opinion/components/BubbleCommon';
import React from 'react';
import { Button } from 'tea-component';
import { useHistory, useIntl } from 'umi';

export default function UrlButton({
  bubbleContent,
  url,
  buttonText,
  disabled,
  showBtn = true,
}: {
  bubbleContent?: TipsMapType | null | undefined;
  url: string;
  buttonText: string;
  disabled?: boolean;
  showBtn?: boolean;
}) {
  const history = useHistory();
  const { formatMessage } = useIntl();
  if (!showBtn) {
    return null;
  }
  return (
    <BubbleCommon
      showIcon={false}
      placement="bottom-end"
      dark
      tipsMap={bubbleContent}
    >
      <Button
        disabled={disabled}
        onClick={() => history.push(url)}
        type="text"
        className="dbo-performance-link ns-btn--border"
      >
        {formatMessage({ id: buttonText })}
        <SvgIcon className="dbo-performance-link-svg" type="arrow-right" />
      </Button>
    </BubbleCommon>
  );
}
